import UpdatePatientForm from 'components/form/admin/patient/UpdatePatientForm'
import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'

export default class UpdatePatient extends Component {
    render() {
        return (
            <>
             <div className="page-content">
                    <Container fluid>
                        <Row>
                            <Col xl='12'>
                                <h4 className="mb-0 font-size-18"> Update Patient</h4>
                                <UpdatePatientForm/>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
